import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ElementRef } from "@angular/core";
import { CapacitorCalendar } from "@ebarooni/capacitor-calendar";
import { DomSanitizer } from "@angular/platform-browser";
import { NavController, NavParams, Platform, AlertController, ModalController, IonicModule, LoadingController } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { EnderecoPipe } from "src/app/pipes/endereco/endereco";
import { EventoProvider } from "src/app/services/evento/evento";
import { UserProvider } from "src/app/services/user/user";
import { EncontroPage } from "../encontro/encontro.page";
import { LoginPage } from "../../login/login.page";
import { Browser } from "@capacitor/browser";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { SafeHtmlPipe } from "src/app/pipes/safe-html/safe-html";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { VideoPlayerComponent } from "src/app/components/video-player/video-player";
import { MoneyPipe } from "src/app/pipes/money/money";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { isBefore } from "date-fns";
import { register } from 'swiper/element/bundle';
import { EncontrosPassadosPage } from "../encontros-passados/encontros-passados.page";
import { ImagePipe } from "src/app/pipes/image/image";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
register();
declare var instituicaoConstants: { IS_PWA: boolean };

@Component({
  selector: "app-evento-detalhes",
  templateUrl: "./evento-detalhes.page.html",
  styleUrls: ["./evento-detalhes.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SafeHtmlPipe,
    ImagePipe,
    SemRegistroComponent,
    VideoPlayerComponent,
    EnderecoPipe,
    MoneyPipe,
    NomenclaturaPipe,
    LoadingSpinnerComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EventoDetalhesPage implements OnInit {
  @ViewChild('swiperEl', { static: false }) swiperElement!: ElementRef;
  @ViewChild('swiperP', { static: false }) swiperP!: ElementRef;
  evento: any = {
    endereco: {},
    tipo: {},
    configuracao: { confDecode: {} },
    encontros: [] as any[],
  };
  eventoTipo: string;
  isEnsino: boolean = false;
  instituicaoConstants: any = {};
  encontrosPassados: any = [];
  maior: any;
  menor: any;
  loaded = false;
  enderecoPipe = new EnderecoPipe();
  linkExterno: any;
  soma: any;
  somaInicial: any;
  config: any;
  inscricao_avulsa: any;
  @ViewChild("divDetalhes")
  divDetalhes!: { nativeElement: HTMLElement };
  layout: any = [];
  configLayout: any = {};
  tipoEvento: any;
  displayTimeEvento: any;
  timerEvento: any;
  showEndereco: number;
  organizadores: any;
  quantidadeInscritos: number;
  textoInscritos: string;
  isOrganizador = false;
  userID: number;
  visibleEncontros: any[] = [];
  visibleEncontrosPassados: any[] = [];
  loadStep = 7;
  userUuid: string;
  hasLinkIntegracao = false;
  exibirDataValidade = 0;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public eventoProvider: EventoProvider,
    private translate: TranslateService,
    public platform: Platform,
    public userProvider: UserProvider,
    public alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer,
    public pessoaProvider: PessoaProvider,
    public loadingCtrl: LoadingController
  ) {
    this.eventoTipo = "atuais";
    this.instituicaoConstants = instituicaoConstants;
    this.isEnsino = this.navParams.get("isEnsino");
    this.userID = this.userProvider.loggedUser.id;
    this.buscar();
  }

  ngOnInit() { }

  initSwiper() {
    if (!this.swiperElement?.nativeElement) return;
    if (!this.swiperP?.nativeElement) return;
    const swiperPassados = this.swiperP.nativeElement;

    Object.assign(swiperPassados, {
      slidesPerView: 1.1,
      spaceBetween: 10,
      preloadImages: false,
      lazy: { loadPrevNext: true, loadPrevNextAmount: 1 },
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
    });    

    const swiperEl = this.swiperElement.nativeElement;

    Object.assign(swiperEl, {
      slidesPerView: 1.1,
      spaceBetween: 10,
      preloadImages: false,
      lazy: { loadPrevNext: true, loadPrevNextAmount: 1 },
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
    });

    swiperPassados.initialize?.();
    swiperEl.initialize?.();
  }

  buscar() {
    if (!this.userProvider.isAnonimo()) {
      this.pessoaProvider.getbyId(this.userID).subscribe((data) => {
        this.userUuid = data.uuid;
      });
    }

    this.eventoProvider.getById(this.navParams.get("id")).subscribe((data: any) => {
      this.hasLinkIntegracao = data.hasLinkIntegracao;
      this.config = data.config.configInscreverApp;
      this.showEndereco = data.configuracao.show_endereco;
      this.layout = data.layout;
      this.soma = data.soma;
      this.somaInicial = data.somaInicial;
      this.layout.forEach((layouts: { tipo: string; conteudo: any }) => {
        if (layouts.tipo == "1") {
          layouts.conteudo = this.sanitizer.bypassSecurityTrustHtml(layouts.conteudo);
        }
      });

      this.configLayout = {
        text_color: data.configuracao.text_color,
      };
      this.isEnsino = data.entidade == "ensino" ? true : false;
      this.evento = data;
      this.visibleEncontros = this.evento.encontros.slice(0, this.loadStep);

      this.eventoProvider.getEncontrosPassados(this.evento.uuid).subscribe((data: any) => {
        this.encontrosPassados = data;
        this.visibleEncontrosPassados = this.encontrosPassados.slice(0, this.loadStep);
      });
      this.organizadores = data.responsaveis;
      this.tipoEvento = data.entidade;
      this.evento.tema = this.evento.tema.toLowerCase();
      this.evento.tipo.nome = this.evento.tipo.nome.toLowerCase();
      this.linkExterno = data.linkInscricao;
      this.inscricao_avulsa = data.inscricao_avulsa;
      this.exibirDataValidade = data.configuracao.hide_date;

      if (this.evento.custo.length) {
        let valores: any[] = [];
        this.evento.custo.forEach((valor: { valor: any }) => {
          valores.push(valor.valor);
        });

        this.maior = Math.max.apply(null, valores);
        this.menor = Math.min.apply(null, valores);
      }
      this.totalInscritos();
      this.verificaOrganizador(this.organizadores);
      let agora = new Date();

      if (isBefore(agora, new Date(this.evento.dataInicio))) {
        this.timerEvento = setInterval(() => {
          this.displayTimeEvento = this.getTimeDiff(new Date(this.evento.dataInicio), false);
        }, 1000);
      } else {
        this.displayTimeEvento = false;
      }

      setTimeout(() => {
        this.initSwiper();
        this.loaded = true;
      }, 1000);
    });
  }

  private getTimeDiff(datetime: string | Date, useAsTimer = false) {
    const targetTime = new Date(datetime).getTime();
    const now = new Date().getTime();
    if (isNaN(targetTime)) return "";
    let diff = useAsTimer ? now - targetTime : targetTime - now;
    if (diff <= 0) {
      this.stopTimer();
      return false;
    }
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    diff -= days * (1000 * 60 * 60 * 24);

    const hours = Math.floor(diff / (1000 * 60 * 60));
    diff -= hours * (1000 * 60 * 60);

    const minutes = Math.floor(diff / (1000 * 60));
    diff -= minutes * (1000 * 60);

    const seconds = Math.floor(diff / 1000);

    const dayString = days ? this.twoDigit(days) : "";

    return this.formatTimer(dayString, { hours, minutes, seconds });
  }

  private formatTimer(dayString: string, time: { hours: number; minutes: number; seconds: number }) {
    const h = this.twoDigit(time.hours);
    const m = this.twoDigit(time.minutes);
    const s = this.twoDigit(time.seconds);
    return `${dayString ? dayString + (Number(dayString) > 1 ? " Dias " : " Dia ") : ""}${h}:${m}:${s}`;
  }

  private twoDigit(n: number) {
    return n.toString().padStart(2, "0");
  }

  private stopTimer() {
    clearInterval(this.timerEvento);
    this.timerEvento = undefined;
  }

  pad(valor: number): string {
    return valor.toString().padStart(2, "0");
  }

  getNomenclatura(tipoEvento: string) {
    return tipoEvento == "ensino" ? "ensino" : "evento";
  }

  getColor(type: string) {
    if (type == "text") {
      return this.configLayout.text_color;
    }
  }

  async openEncontro(encontro: any) {
    const data = {
      encontro: encontro,
      isEnsino: this.isEnsino ? true : false,
      isAdmin: this.evento.isAdmin,
      responsaveis: this.evento.responsaveis,
      isAvulso: this.inscricao_avulsa,
      checkInAntecipado: this.evento.configuracao.checkInAntecipado,
      tipoEvento: this.tipoEvento,
      exibirDataValidade: this.exibirDataValidade
    };
    const modalPage = await this.modalCtrl.create({
      component: EncontroPage,
      componentProps: data,
    });
    modalPage.present();
  }

  async openLinkExterno() {
    if (this.userProvider.isAnonimo()) {
      let alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant("Necessário Login"),
        message: this.translate.instant("Para utilizar essa funcionalidade é necessário fazer login"),
        buttons: [
          {
            text: this.translate.instant("Cancelar"),
            handler: () => { },
          },
          {
            text: this.translate.instant("Fazer Login"),
            handler: async () => {
              let modalPage = await this.modalCtrl.create({
                component: LoginPage,
                componentProps: { mostrarHeader: true },
              });
              modalPage.present();
            },
          },
        ],
      });

      alert.present();
    } else {
      if (this.evento.isLunaris && !this.evento.isInscrito) {
        this.isLinkLunaris()
        return;
      }

      this.openLink(this.linkExterno)
    }
  }

  async openLink(urlLink: string) {
    if (this.platform.is("ios") && instituicaoConstants.IS_PWA === true) {
      try {
        await Browser.open({ url: urlLink });
        this.buscar();
      } catch (err) {
        console.error("Erro ao abrir o link:", err);
      }
    } else {
      try {
        await Browser.open({ url: urlLink });
        this.buscar();
      } catch (err) {
        console.error("Erro ao abrir o link:", err);
      }
    }

    this.loaded = true;
  }

  async isLinkLunaris() {
    const loading = await this.loadingCtrl.create({
      message: 'Autenticando...'
    });

    await loading.present();
    try {
      this.eventoProvider
        .loginExterno(
          this.userUuid,
          this.evento.slug,
          this.evento.instituicaoSlug,
          this.evento.isInscrito
        ).subscribe(async (result) => {
          const url = this.linkExterno + `?token=${result.token}` + `&hash=${result.hash}`;
          this.openLink(url)
        })
    } catch (err) {
      this.openLink(this.linkExterno);
    } finally {
      loading.dismiss();
    }

    this.loaded = true;
  }

  async openAnexo(anexo: string) {
    await Browser.open({ url: environment.DOWNLOAD_URL + "/" + anexo });
  }

  async calendario(evento: { encontros: string | any[]; tema: string | undefined; observacao: string | undefined }) {
    if (instituicaoConstants.IS_PWA === true) {
      this.eventoProvider.icsCalendar(this.evento.id).subscribe((data: any) => {
        window.open("data:text/calendar;charset=utf8," + encodeURI(data));
        this.loaded = true;
      });
    } else {
      const inicio = new Date(evento.encontros[0].dataInicio);
      const fim = new Date(evento.encontros[evento.encontros.length - 1].dataFim);

      try {
        await CapacitorCalendar.requestFullCalendarAccess();

        await CapacitorCalendar.createEventWithPrompt({
          title: evento.tema || "",
          location: "",
          description: evento.observacao || "",
          startDate: inicio.getTime(),
          endDate: fim.getTime(),
        });
      } catch (err) {
        console.error("Erro ao criar evento:", err);
      }
    }
  }

  async addPessoas() {
    let auxLang = this.instituicaoConstants.LINGUAGEM ? "es" : "";
    if (this.platform.is("ios") && instituicaoConstants.IS_PWA === true) {
      try {
        await Browser.open({
          url: environment.INTEGRACAO_URL + "/evento/dados-gerais/" + this.evento.uuid + "/?app=1&lang=" + auxLang,
        });
        this.buscar();
      } catch (err) {
        console.error("Erro ao abrir o link:", err);
      }
    } else {
      try {
        await Browser.open({
          url: environment.INTEGRACAO_URL + "/evento/dados-gerais/" + this.evento.uuid + "/?app=1&lang=" + auxLang,
        });
        this.buscar();
      } catch (err) {
        console.error("Erro ao abrir o link:", err);
      }
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
    this.loaded = true;
  }
  get spanDecorado(): string {
    const original = this.evento.span;
    if (!original) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = original;

    const texto = tempDiv.textContent?.trim() || "";

    const traduzido = this.translate.instant(texto);

    if (/gratuito/i.test(texto)) {
      return `<span class="date-evento gratuito">${traduzido}</span>`;
    }

    const partes = texto.split("R$");
    if (partes.length === 2) {
      const prefixo = partes[0].trim();
      const valor = "R$ " + partes[1].trim();

      const prefixoTraduzido = this.translate.instant(prefixo);

      return `
      <span class="formt">${prefixoTraduzido}</span>
      <br>
      <span class="valor-eventos">${valor}</span>
    `;
    }

    return `<span>${traduzido}</span>`;
  }

  abrirMapa(endereco: any) {
    const url = "http://maps.google.com/?q=" + this.enderecoPipe.transform(endereco, true);
    window.open(url, "_blank");
  }

  voltarAoPrimeiroSlide() {
    if (this.swiperElement?.nativeElement?.swiper) {
      this.swiperElement.nativeElement.swiper.slideTo(0);
    }
  }

  voltarPrimeiroSlide() {
    if (this.swiperP?.nativeElement?.swiper) {
      this.swiperP.nativeElement.swiper.slideTo(0);
    }
  }

  totalInscritos() {
    this.eventoProvider.quantidadeInscritos(this.navParams.get('id')).subscribe((data) => {
      this.quantidadeInscritos = +data;
      let mensagemInscritos = 'Sem inscritos';

      if (this.quantidadeInscritos >= 1) {
        mensagemInscritos = this.quantidadeInscritos === 1 ? 'inscrito' : 'inscritos';
      }

      this.textoInscritos = this.translate.instant(mensagemInscritos);
    });
  }

  verificaOrganizador(organizadores: any) {
    if (organizadores) {
      for (const responsavel of organizadores) {
        if (responsavel.id === this.userID) {
          this.isOrganizador = true;
          break;
        }
      }
    }
  }

  async openListEncontros(encontro: any) {
    const data = {
      evento: this.evento,
      encontros: encontro,
      isEnsino: this.isEnsino ? true : false,
      isAvulso: this.inscricao_avulsa,
      checkInAntecipado: this.evento.configuracao.checkInAntecipado,
      tipoEvento: this.tipoEvento,
    };

    const modalPage = await this.modalCtrl.create({
      component: EncontrosPassadosPage,
      componentProps: data,
    });
    modalPage.present();
  }
}
